module.exports = __webpack_public_path__ + "static/media/reportes.61b733ba.png";